<template>
  <v-card class="mt-2" v-if="atividadeNotificacao.Notificacoes.length">
    <v-toolbar card :dense="$vuetify.breakpoint.mdAndUp">
      <v-layout :column="$vuetify.breakpoint.smAndDown" :align-center="$vuetify.breakpoint.mdAndUp">
        <v-flex xs12 md6>
          <div class="d-flex font-weight-bold align-center">
            {{ atividadeNotificacao.TipoNotificacao }}:
            <router-link class="pl-1 text-truncate" :to="{ name: 'altera atividade', params: { id: atividadeNotificacao.IdAtividade } }">
              {{ atividadeNotificacao.Atividade }}
            </router-link>
            <div v-if="$vuetify.breakpoint.smAndDown" class="text-xs-right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn @click="marcaTodasLida" flat icon small v-on="on">
                    <v-icon>check</v-icon>
                  </v-btn>
                </template>
                <span>Marcar todas como lida</span>
              </v-tooltip>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md4 class="text-truncate" :class="{ 'pb-2': $vuetify.breakpoint.smAndDown }">
          <span class="caption font-italic">Clientes: {{ atividadeNotificacao.Clientes }}</span>
        </v-flex>
        <v-flex v-if="$vuetify.breakpoint.mdAndUp" xs2 md2 class="text-xs-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="marcaTodasLida" flat icon small v-on="on">
                <v-icon>check</v-icon>
              </v-btn>
            </template>
            <span>Marcar todas como lida</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-title class="pa-0" primary-title>
      <v-flex xs12>
        <NotificacaoItem 
          v-for="notificacao in atividadeNotificacao.Notificacoes"
          :key="notificacao.IdNotificacao" 
          :notificacao="notificacao"
        />
      </v-flex>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import NotificacaoItem from '@/components/notificacao/NotificacaoItem';
import AtividadeNotificacao from '@/domain/notificacao/AtividadeNotificacao';

export default {
  name: 'NotificacaoContainer',
  props: {
    atividadeNotificacao: {
      type: Object,
      default: () => new AtividadeNotificacao()
    },
  },
  components: {
    NotificacaoItem
  },
  methods: {
    ...mapActions(['marcaNotificacaoLida', 'fetchAtividadeByIdNode']),
    ...mapMutations(['showNotification', 'closeNotification']),
    iconStatusOcorrencia(status) {
      return status == 'P' ? 'radio_button_unchecked' : 'check_circle';
    },
    colorIconStatusOcorrencia(status) {
      return status == 'P' ? 'default' : 'success';
    },
    async marcaTodasLida() {
      for (const notificacao of this.atividadeNotificacao.Notificacoes) {
        if (notificacao.Status.trim() == 'P') {
          notificacao.Status = 'F';
          await this.marcaNotificacaoLida(notificacao);
        }
      }
      this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' });
    },
    tipText(status) {
      return status.trim() == 'A' ? 'Marcar como lida' : 'Marcar como não lida';
    }
  }
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #ddd;
}

.border-bottom:last-child {
  border-bottom: none;
}
</style>